import { releases as pr } from './pressreleases';

const releases = pr;
const verifyWebp = document.querySelector('html');

const showReleases = releases => {
  const releasesHTML = releases
    .map((release, index) => {
      const isEven = index % 2 === 0;
      const timelineClass = isEven ? 'timeline__row--reverse' : '';
      const image = verifyWebp.classList.contains('webp')
        ? release.imagewebp
        : release.image;

      return `
  <aside class="timeline__row ${timelineClass}" role="region" aria-labeledby="release-${release.id}-title">
    <div class="timeline__date" aria-hidden="true">${release.date_to_show}</div>
    <div class="timeline__image ${isEven ? 'timeline__fadeRight' : 'timeline__fadeLeft'}">
      <img src="${image}" alt="image for the press release" />
    </div>
    <div class="timeline__content ${isEven ? 'timeline__fadeLeft' : 'timeline__fadeRight'}">
      <div class="heading__secondary heading__secondary--black heading__secondary--thin" id="release-${release.id}-title">
        ${release.title}
      </div>
      <p>${release.blurb}</p>
      <a
        href="#pr__modal"
        aria-label="View ${release.title}"
        class="gtm__release"
        data-release="${release.id}"
        data-id="${release.id}"
      >
        <div class="release__learnmore">Learn More</div>
      </a>
    </div>
  </aside>
`;
    })
    .join('');

  const wrapper = document.querySelector('.timeline__wrapper');

  wrapper.innerHTML = releasesHTML;

  window.scrollTo({ top: 0, behavior: 'smooth' });

  setTimeout(() => {
    initializeObservers();
    setupModal();
  }, 700); // Adjust delay time as needed
};

const initializeObservers = () => {
  const release__rows = document.querySelectorAll('.timeline__row');

  const releases__right = document.querySelectorAll('.timeline__fadeRight');
  const releases__left = document.querySelectorAll('.timeline__fadeLeft');
  const releases__date = document.querySelectorAll('.timeline__date');

  // Determine rootMargin based on screen size
  const isMobile = window.innerWidth <= 768;
  const rootMarginMobile = '0px 0px -300px 0px';
  const rootMarginDesktop = '0px 0px -650px 0px';
  const rootMarginDesktopLower = '0px 0px -500px 0px';

  // Set rootMargin based on device type
  const rootMargin = isMobile ? rootMarginMobile : rootMarginDesktop;
  const rootMarginLower = isMobile ? rootMarginMobile : rootMarginDesktopLower;

  // Observer options
  const options = { rootMargin };
  const optionsLower = { rootMarginLower };

  // observer for dots
  const animateDot = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('timeline__row--active');
      }
    });
  }, options);

  // observer for text/image to fade up
  const animateUp = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('fadeInUp');
      }
    });
  }, options);

  // observer for text/image
  const animateRight = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('fadeInRight');
      }
    });
  }, optionsLower);

  const animateLeft = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('fadeInLeft');
      }
    });
  }, optionsLower);

  // Start observing - for dots
  release__rows.forEach(row => {
    animateDot.observe(row);
  });

  releases__right.forEach(item => {
    animateRight.observe(item);
  });

  releases__left.forEach(item => {
    animateLeft.observe(item);
  });

  releases__date.forEach(item => {
    animateUp.observe(item);
  });
};

const setupModal = () => {
  const modal = document.querySelector('.modal__pr');
  const close = document.querySelector('.modal__pr__close');
  const release_items = document.querySelectorAll('.timeline__row a');
  const title = document.querySelector(
    '.modal__pr__body__wrapper .heading__secondary',
  );

  const mainText = document.querySelector('.modal__pr__body__group__text');

  const sourceElement = document.querySelector(
    '.modal__pr__body__group__img picture source',
  );

  const imgElement = document.querySelector(
    '.modal__pr__body__group__img picture img',
  );

  const closeModal = () => {
    modal.classList.add('modal__pr__hide');
  };

  close.addEventListener('click', closeModal);
  close.addEventListener('keydown', evt => {
    if (evt.key === 'Enter' || evt.key === ' ') {
      closeModal();
    }
  });

  window.addEventListener('keydown', evt => {
    if (evt.key === 'Escape') {
      closeModal();
    }
  });

  window.addEventListener('click', evt => {
    if (evt.target === modal) {
      closeModal();
    }
  });

  release_items.forEach(item => {
    item.addEventListener('click', evt => {
      evt.preventDefault();
      const releaseId = item.dataset.id;
      // Find the corresponding release data
      const release = releases.find(r => r.id === parseInt(releaseId, 10));
      if (release) {
        title.textContent = release.title;
        mainText.innerHTML = release.story;
        imgElement.src = release.image;
        sourceElement.srcset = release.imagewebp;
      }
      modal.classList.remove('modal__pr__hide');
    });
  });
};

const setupDropdowns = () => {
  // Select the dropdown menus
  const archivesMenu = document.querySelector(
    '.stickybar__dropdown:nth-child(1) .stickybar__dropdown__menu',
  );
  const categoriesMenu = document.querySelector(
    '.stickybar__dropdown:nth-child(3) .stickybar__dropdown__menu',
  );

  // Define the years and keywords
  const years = Array.from(
    { length: new Date().getFullYear() - 2016 + 1 },
    (_, i) => new Date().getFullYear() - i,
  );
  const keywords = [
    'Defense',
    'Federal',
    'Contract',
    'Awarded',
    'Government',
    'Innovation',
    'Technology',
    'Supply Chain',
    'Logistics',
    'Leadership',
    'Mission',
    'Capabilities',
    'Program',
    'Management',
  ];

  // Populate the Archives (Years) menu
  years.forEach(year => {
    const li = document.createElement('li');
    li.setAttribute('role', 'menuitem');
    li.innerHTML = `<a href="#" data-date=${year} class="gtm__date">${year}</a>`;
    archivesMenu.appendChild(li);
  });

  // Populate the Categories (Keywords) menu
  keywords.forEach(keyword => {
    const li = document.createElement('li');
    li.setAttribute('role', 'menuitem');
    li.innerHTML = `<a href="#" data-content=${keyword} class="gtm__content">${keyword}</a>`;
    categoriesMenu.appendChild(li);
  });

  // Add toggle functionality to dropdown buttons
  document.querySelectorAll('.stickybar__dropdown__button').forEach(button => {
    button.addEventListener('click', () => {
      const menu = button.nextElementSibling;
      menu.parentElement.classList.toggle('open');
    });
  });

  // Close dropdowns when clicking outside
  document.addEventListener('click', e => {
    document.querySelectorAll('.stickybar__dropdown').forEach(dropdown => {
      if (!dropdown.contains(e.target)) {
        dropdown.classList.remove('open');
      }
    });
  });

  const dropdownLinks = document.querySelectorAll(
    '.stickybar__dropdown__menu li a',
  );

  dropdownLinks.forEach(link => {
    link.addEventListener('click', evt => {
      evt.preventDefault();
      const dateFilter = link.dataset.date; // For year filtering
      const contentFilter = link.dataset.content?.toLowerCase(); // For keywords

      const filteredReleases = releases.filter(release => {
        if (dateFilter) {
          return release.date.includes(dateFilter); // Match the year
        }
        if (contentFilter) {
          return release.story.toLowerCase().includes(contentFilter);
        }
        return false;
      });

      const dropdown = link.closest('.stickybar__dropdown');
      dropdown?.classList.remove('open');

      showReleases(filteredReleases);
    });
  });

  const showAll = document.querySelector('.stickybar__all');
  showAll.addEventListener('click', evt => {
    evt.preventDefault();
    showReleases(releases);
  });

  window.addEventListener('resize', () => {
    const dropdowns = document.querySelectorAll('.stickybar__dropdown');
    dropdowns.forEach(dropdown => {
      dropdown?.classList.remove('open');
    });
  });
};

// Initialize everything
document.addEventListener('DOMContentLoaded', () => {
  showReleases(releases);
  setupModal();
  setupDropdowns();
});
